import { Component, OnInit, HostListener } from '@angular/core';
import { Router, NavigationStart, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Location, PopStateEvent } from "@angular/common";
import { ContextService } from './shared';


@Component({
 selector: 'app-root',
 template: `
 	<div id="wrapper">
	 	<div class="overlay"></div>
		<layout-header></layout-header>
		<main [ngClass]="{'famille': area=='B2C'}">
		<router-outlet></router-outlet>
		</main>
		<layout-footer></layout-footer>
	</div>
 `
})
export class AppComponent implements OnInit {
	private lastPoppedUrl: string;
	area: string;
    private yScrollStack: number[] = [];


 constructor (private router: Router, private location: Location,  private activatedRoute: ActivatedRoute,   private contextService: ContextService,) {
// 	this.router.events.subscribe(event => {
// 		if(event instanceof NavigationEnd){
// 			(<any>window).ga('set', 'page', event.urlAfterRedirects);
//        	(<any>window).ga('send', 'pageview');
// 		}
// 	});
 }

 ngOnInit() {
 	 this.router.events.subscribe((ev:any) => {
         if (ev instanceof NavigationEnd ) {
	    	let url =ev.url.split("/");
          	this.area = (url[1] && url[1]=='familles') ? 'B2C':'B2B';
          	this.contextService.setContext(this.area);

          	// if(this.contextService.getContext != this.area){

          	// }
          	//console.log(url);
	    }
	});
    
    /*this.router.events.subscribe((ev:any) => {
        window.scrollTo(0, 0);
    });*/
 }

}


// WEBPACK FOOTER //
// ./src/app/app.component.ts